import { MuiTableBody, MuiTableCell } from '../../../base-components';
import { ReactNode } from 'react';
import { StyledTableRow } from '../Row/Row.styles';
import { useTranslation } from 'react-i18next';

interface IEmptyTableBodyProps {
    emptyTableComponent?: ReactNode;
}
const EmptyTableBody = (props: IEmptyTableBodyProps) => {
    const { emptyTableComponent } = props;
    const { t } = useTranslation();
    return (
        <MuiTableBody>
            <StyledTableRow
                key={'notFound'}
                isReadOnly={true}
                isRowClickable={false}
            >
                <MuiTableCell colSpan={50} sx={{ textAlign: 'center' }}>
                    {emptyTableComponent || t('tablesBase.noDataFound')}
                </MuiTableCell>
            </StyledTableRow>
        </MuiTableBody>
    );
};
export default EmptyTableBody;
